import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';
import { Variables } from 'styles/variables/variables';

const { lightRed, orange, deepOrange, lightGrayBorder, gray, white, darkGray } = Colors;
const { assistant, montserrat } = Variables;

type Props = {
    secondary: boolean;
};

export const BottomContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 2rem;
    margin-top: 2rem;
`;

export const InfoIconContainer = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const Message = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '400', fontFamily: assistant })};
    font-style: normal;
    line-height: 20px;
    text-align: center;
`;

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px;
`;

export const Button = styled.button<Props>`
    width: fit-content;
    padding: 12px 16px;
    background-color: ${({ secondary }) =>
        secondary ? `${white} !important` : `${orange} !important`};
    border-radius: 4px;
    border: ${({ secondary }) => (secondary ? `2px solid ${lightGrayBorder}` : ``)};
    ${TextStyle({ fontSize: '12px', fontWeight: '500', fontFamily: montserrat })};
    color: ${({ secondary }) => (secondary ? `${darkGray} !important` : `${white} !important`)};
    font-style: normal;
    line-height: 17px;
    text-transform: capitalize;
    transition: all 110ms ease-out;

    &:hover {
        background-color: ${({ secondary }) =>
            secondary ? `${lightGrayBorder} !important` : `${deepOrange} !important`};
    }

    &:active {
        opacity: 0.9;
    }

    &:disabled {
        background-color: ${lightGrayBorder};
        color: ${gray};
        cursor: not-allowed;
    }

    &:focus-visible {
        box-shadow: 0px 0px 7px 2px ${deepOrange};
        outline: none;
    }
`;

export const TopContainer = styled.div`
    position: relative;
    background-color: ${lightRed};
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: auto;
    margin-bottom: 16px;
`;
